import "../../../shared/client/jst.js";
import "../../../utilities/iso_date.js";
import "../../../utilities/appointment_date.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.ProviderWidget ??= {};
window.AppointmentBooking.ProviderWidget.Views ??= {};

AppointmentBooking.ProviderWidget.Views.SlotList = class SlotList extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.openAppointmentModal = this.openAppointmentModal.bind(this);
    this.triggerSlotPick = this.triggerSlotPick.bind(this);
    this.triggerEvent = this.triggerEvent.bind(this);
  }

  // EVENT HANDLERS

  handleOpenAppointmentModalClick() {
    return this.openAppointmentModal();
  }

  handleAppointmentSlotClick(event) {
    const slot = {}; // TODO: populate slot data
    return this.triggerSlotPick(slot, event.currentTarget);
  }

  // RENDERING

  render() {
    const selectedPatientType = this.model.get("selectedPatientType");
    const selectedAddress = this.model.get("selectedAddress").toJSON();
    const walkInOptions = this.model.get("selectedAddress").get("walk_in") || {};
    let schedulingOptions = this.model.get("selectedAddress").get("scheduling") || {};
    schedulingOptions = schedulingOptions[selectedPatientType] || {};

    return this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        walkInOptions,
        schedulingOptions,
        selectedPatientType,
        selectedAddress,
        I18n: AppointmentBooking.config.i18n.provider_widget,
        testIds: AppointmentBooking.config.test_ids,
      }),
    );
  }

  // DSL

  // Without a slot to focus, the modal opens on today's date.
  openAppointmentModal() {
    let focusDate;
    const address = this.model.get("selectedAddress");
    const selectedPatientType = this.model.get("selectedPatientType");

    const firstSlot = address.get("scheduling")?.[selectedPatientType]?.slots?.[0];
    if (firstSlot) {
      focusDate = Sparkle.Utilities.isoDate(moment.parseZone(firstSlot.start_time));
    }

    const filters = {
      resource_type: this.model.get("providerType"),
      resource_id: this.model.get("providerId"),
      department_id: address.get("department_id"),
      patient_type: selectedPatientType === "new_patient" ? "new" : "returning",
    };

    return AppointmentBooking.showSlotPickerModal({
      focusDate,
      filters,
      options: { onSlotPick: this.triggerSlotPick },
    });
  }

  // PRIVATE

  triggerSlotPick(slot, slotElement) {
    return this.triggerEvent(AppointmentBooking.ProviderWidget.Events.slotPick, slot, slotElement);
  }

  // Used to communicate UI interaction events up to parent views
  triggerEvent(event, ...payload) {
    this.$el.trigger(event, payload);
    return this.trigger(event, ...Array.from(payload));
  }
};
AppointmentBooking.ProviderWidget.Views.SlotList.prototype.template =
  "appointment_booking/provider_widget/templates/_slot_list";

AppointmentBooking.ProviderWidget.Views.SlotList.prototype.events = {
  'click [data-appointment-booking-provider-widget-behaviour="open-appointment-modal"]':
    "handleOpenAppointmentModalClick",
  'click [data-appointment-booking-provider-widget-behaviour="appointment-slot"]': "handleAppointmentSlotClick",
};
